module.exports = __webpack_public_path__ + "img/whologram.09cb58e0.jpg";